import { useEffect } from "react";

const CountryDropdownPanel = ({
  selectedCountry,
  onSelect,
  isOpen,
  onToggle,
  groups,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === "Escape") onToggle(false);
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [isOpen, onToggle]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="country-dropdown-backdrop"
        onClick={() => onToggle(false)}
      />
      <div className="country-dropdown-wrapper">
        <div className="country-dropdown">
          <div className="country-dropdown-body">
            {groups.map((group, gi) => (
              <div className="country-group" key={gi}>
                <h4 className="country-group-label">{group.label}</h4>
                <ul className="country-group-items">
                  {group.items.map((item) => (
                    <li
                      key={item.name}
                      className={`country-item ${
                        selectedCountry.name === item.name ? "active" : ""
                      }`}
                      onClick={() => onSelect(item)}
                    >
                      <span className="country-item-dot" />
                      {item.name}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="country-dropdown-handle">
            <div className="handle-pill" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CountryDropdownPanel;
